export function calculateComponentGroupStatus(components = []) {

	if(components?.length <=0 ) return false ;

	const totalUniqueComponents = components?.length

	const groupByStatus = components.reduce((group, item) => {
		const { status } = item;
		group[status] = group[status] ?? 0;
		group[status] += 1
		return group;
		}, {});
	
	 

	let groupStatus = '';

	// !If all components have a status of 'Operational', top-level status will read 'All Systems Operational'
	if(typeof groupByStatus['OPERATIONAL']!=='undefined' && groupByStatus['OPERATIONAL'] === totalUniqueComponents)
		groupStatus = 'OPERATIONAL';

	// !If all components have a status of 'Major Outage', top-level status will read 'Major System Outage'
	else if(typeof groupByStatus['MAJOR-OUTAGE']!=='undefined' && groupByStatus['MAJOR-OUTAGE'] === totalUniqueComponents)
		groupStatus = 'MAJOR-OUTAGE';
		
	// !If all components have a status of 'Partial Outage', top-level status will read 'Partial System Outage'
	else if(typeof groupByStatus['PARTIAL-OUTAGE']!=='undefined' && groupByStatus['PARTIAL-OUTAGE'] === totalUniqueComponents)
		groupStatus = 'PARTIAL-OUTAGE';
		
	// !If any components have a status of 'Major Outage', top-level status will read 'Partial System Outage'
	else if(typeof groupByStatus['MAJOR-OUTAGE']!=='undefined' && groupByStatus['MAJOR-OUTAGE'] >= 1)
		groupStatus = 'PARTIAL-OUTAGE';

	// !If any components have a status of 'Partial Outage', top-level status will read 'Minor Service Outage'
	else if(typeof groupByStatus['PARTIAL-OUTAGE']!=='undefined' && groupByStatus['PARTIAL-OUTAGE'] >= 1)
		groupStatus = 'PARTIAL-OUTAGE';

	// !If all components have a status of 'Degraded Performance', top-level status will read 'Degraded System Service'
	else if(typeof groupByStatus['DEGRADED-PERFORMANCE']!=='undefined' && groupByStatus['DEGRADED-PERFORMANCE'] === totalUniqueComponents)
		groupStatus = 'DEGRADED-PERFORMANCE';

	// !If any components have a status of 'Degraded Performance', top-level status will read 'Partially Degraded Service'
	else if(typeof groupByStatus['DEGRADED-PERFORMANCE']!=='undefined' && groupByStatus['DEGRADED-PERFORMANCE'] >= 1)
		groupStatus = 'DEGRADED-PERFORMANCE';

	// !If any components have a status of 'Under Maintenance', top-level status will read 'System Under Maintenance'
	else if(typeof groupByStatus['UNDER-MAINTENANCE']!=='undefined' && groupByStatus['UNDER-MAINTENANCE'] >= 1)
		groupStatus = 'UNDER-MAINTENANCE';


	return groupStatus ;
	
}